export class W4D_Nav_Swipe {
	constructor($navInner, $header, onCloseCallback) {
		this.$navInner = $navInner;
		this.$header = $header;
		this.onClose = onCloseCallback;

		this.swipe = {
			startX: 0,
			startY: 0,
			currentX: 0,
			startTime: 0,
			isActive: false,
			isHorizontalSwipe: false,
			threshold: 50,
			closeThreshold: 0.4,
			durationThreshold: 1000,
		};

		this.init();
	}

	init() {
		if (!('ontouchstart' in window)) return;

		const navInnerElement = this.$navInner[0];
		if (!navInnerElement) return;

		navInnerElement.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: false });
		navInnerElement.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: false });
		navInnerElement.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });
		navInnerElement.addEventListener('touchcancel', (e) => this.handleTouchEnd(e), { passive: true });
	}

	handleTouchStart(e) {
		if (!this.$header.hasClass('w4d-header--open')) return;

		const touch = e.touches[0];
		this.swipe = {
			...this.swipe,
			startX: touch.clientX,
			startY: touch.clientY,
			currentX: touch.clientX,
			startTime: Date.now(),
			isActive: true,
			isHorizontalSwipe: false,
		};

		this.$navInner[0].style.transition = '';
		this.$navInner.addClass('nav__inner--swiping');
	}

	handleTouchMove(e) {
		if (!this.swipe.isActive || !this.$header.hasClass('w4d-header--open')) return;

		const touch = e.touches[0];
		const deltaX = touch.clientX - this.swipe.startX;
		const deltaY = touch.clientY - this.swipe.startY;
		const duration = Date.now() - this.swipe.startTime;

		if (duration > this.swipe.durationThreshold) {
			this.endSwipe(true);
			return;
		}

		if (!this.swipe.isHorizontalSwipe && Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
			this.swipe.isHorizontalSwipe = true;
		}

		if (this.swipe.isHorizontalSwipe && deltaX > 0) {
			e.preventDefault();
			this.swipe.currentX = touch.clientX;

			const navWidth = this.$navInner.outerWidth();
			const swipePercentage = deltaX / navWidth;

			if (swipePercentage >= this.swipe.closeThreshold) {
				this.endSwipe(false);
				return;
			}

			const swipeDistance = Math.max(0, deltaX);
			this.$navInner[0].style.transform = `translateX(${swipeDistance}px)`;
		}
	}

	handleTouchEnd() {
		if (!this.swipe.isActive) return;

		const deltaX = this.swipe.currentX - this.swipe.startX;
		const duration = Date.now() - this.swipe.startTime;
		const navWidth = this.$navInner.outerWidth();
		const swipePercentage = deltaX / navWidth;
		const velocity = this.calculateVelocity(deltaX, duration);

		const shouldClose =
			this.swipe.isHorizontalSwipe &&
			deltaX > this.swipe.threshold &&
			duration <= this.swipe.durationThreshold &&
			(swipePercentage >= this.swipe.closeThreshold || velocity > 0.8);

		this.endSwipe(!shouldClose);
	}

	endSwipe(shouldBounceBack) {
		if (!this.swipe.isActive) return;

		this.swipe.isActive = false;
		this.$navInner.removeClass('nav__inner--swiping');

		if (shouldBounceBack) {
			this.animateNavBounceBack();
		} else {
			this.animateNavClose();
		}

		this.resetSwipeData();
	}

	calculateVelocity(distance, duration) {
		if (duration <= 0) return 0;
		const navWidth = this.$navInner.outerWidth();
		const normalizedDistance = Math.abs(distance / navWidth);
		return normalizedDistance / (duration / 1000);
	}

	animateNavClose() {
		const navWidth = this.$navInner.outerWidth();
		this.$navInner[0].style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
		this.$navInner[0].style.transform = `translateX(${navWidth}px)`;

		setTimeout(() => {
			if (typeof this.onClose === 'function') {
				this.onClose();
			}
		}, 300);
	}

	animateNavBounceBack() {
		this.$navInner[0].style.transition = 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)';
		this.$navInner[0].style.transform = 'translateX(0)';

		setTimeout(() => {
			if (this.$navInner[0]) {
				this.$navInner[0].style.transition = '';
			}
		}, 400);
	}

	resetSwipeData() {
		this.swipe.isActive = false;
		this.swipe.isHorizontalSwipe = false;
		this.swipe.startX = 0;
		this.swipe.currentX = 0;
		this.swipe.startTime = 0;
	}
}
